import React from 'react'
import { StyledTextField } from './styles'

const CustomInpuText = ({ variant, ...otherProps}) => {
    return <StyledTextField variant={variant} {...otherProps}/>
}

export default CustomInpuText